import { useDispatch } from 'react-redux';
import { IonInput, IonItem, IonLabel, IonText } from '@ionic/react';

import { titleize } from 'lib/text';
import { stopPropagation } from 'helpers/events';

import { updateLoad } from 'actions/ProjectDataActions';

export default function LoadInput({unit, loadType, load, helperText, ...props}) {
  const dispatch = useDispatch();
  const changeLoad = ({target}) => {
    const baseValue = unit.toBase(target.value);
    dispatch(updateLoad(load.id, {[loadType]: baseValue}));
  };
  const displayValue = _.round(unit?.toDisplay(load[loadType]), 2) || '';

  return (
    <IonItem>
      <IonLabel>
        {titleize(loadType)}
        {helperText && <p>{helperText}</p>}
      </IonLabel>
      <IonText slot="end">{unit.abbreviation}</IonText>
      <IonInput type="number" min="0" {...props}
        value={displayValue}
        onIonInput={changeLoad}
        onIonChange={stopPropagation(changeLoad)}/>
    </IonItem>
  );
}
